export default class Constants {
    static OTHER_ROUTED_MODULES = ['games', 'signup']
    static PET_NAME_REPLACE_TOKEN = '{Pet}';
}